import {
  COLORS,
  borderRadiusSm,
  marginLg,
  marginMd,
  paddingLg,
  paddingMd,
  paddingSm,
} from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import Input from 'components/Input/Input';
import styled from 'styled-components';

export const Container = styled.div`
  background: ${COLORS.BACKGROUND};
  padding: 50rem 0;
  max-width: 1440rem;
  width: 100%;
  align-self: center;

  ${respondTo.smallLaptop`
    padding: 50rem 15rem;
  `}

  ${respondTo.smallTablet`
    padding: 20rem 15rem;
  `}

  ${respondTo.bigPhone`
    padding: 15rem;
  `};
`;

export const Title = styled.label`
  font-size: 40rem;
  font-weight: 300;
  color: ${COLORS.BLACK};

  ${respondTo.smallTablet`
    font-size: 30rem;
  `}
`;

export const BackWrapper = styled.div`
  margin-bottom: 25rem;
`;

export const RowPaddingBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${marginMd};

  ${respondTo.bigPhone`
    flex-direction: column;
    gap: 20rem;
  `}
`;

export const CategoriesContainer = styled.div`
  background-color: ${COLORS.WHITE};
  border-radius: ${borderRadiusSm};
  width: 100%;
  border: 1rem solid ${COLORS.GRAY_100};
  padding-left: ${paddingMd};
  padding-right: ${paddingMd};
  ${respondTo.bigPhone`
    padding-left: ${paddingSm};
    padding-right: ${paddingSm};
  `}
`;

export const SupplierCompanyName = styled.label`
  font-weight: 400;
  font-size: 24rem;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    font-size: 18rem;
  `}
`;

export const NoContentLabelWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const NoContentLabel = styled.label`
  font-weight: 400;
  font-size: 24rem;
  line-height: 32rem;
  width: 100%;
  text-align: center;
  padding-top: ${paddingLg};
  color: ${COLORS.BLACK};
`;

export const InputWrapper = styled.div`
  display: flex;
  width: 350rem;

  ${respondTo.bigPhone`
    width: 100%;
  `}
`;

export const TitleAndSupplierLabelsWrapper = styled.div`
  display: flex;
  gap: 20rem;
  align-items: center;
  ${respondTo.smallTablet`
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const SkeletonWrapper = styled.div`
  padding-left: 30rem;
  padding-right: 30rem;
  border-radius: ${borderRadiusSm};
  background-color: ${COLORS.WHITE};
`;

export const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50rem;
`;
